import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlanDrawingService {
  private planDrawingCompletedSubject: Subject<boolean> = new Subject<boolean>();

  get planDrawingCompleted$(): Observable<boolean> {
    return this.planDrawingCompletedSubject.asObservable();
  }

  updatePlanDrawingStatus(value: boolean): void {
    this.planDrawingCompletedSubject.next(value);
  }
}
